export default [
  {
    path: "/onlineActivity",
    component: () => import("@/views/onlineActivity/index"),
    children: [
      {
        path: "signActive",
        component: () => import("@/views/onlineActivity/signActive"),
        meta: {
          title: "活动报名"
        }
      },
      {
        path: "signActiveMy",
        component: () => import("@/views/onlineActivity/signActiveMy"),
        meta: {
          title: "活动报名"
        }
      },
      {
        path: "signResult",
        component: () => import("@/views/onlineActivity/signResult"),
        meta: {
          title: "报名结果"
        }
      },
      {
        path: "home",
        component: () => import("@/views/onlineActivity/home"),
        meta: {
          title: "在线活动",
          keeplive: true
        }
      },

      {
        path: "myReport",
        component: () => import("@/views/onlineActivity/components/myReport"),
        meta: {
          title: "我的报名"
        }
      },
      {
        path: "activityReport",
        component: () =>
          import("@/views/onlineActivity/components/activityReport"),
        meta: {
          title: "活动报名"
        }
      },
      {
        path: "reportResult",
        component: () =>
          import("@/views/onlineActivity/components/reportResult"),
        meta: {
          title: "报名结果"
        }
      },
      {
        path: "reportDetial",
        component: () =>
          import("@/views/onlineActivity/components/reportDetial"),
        meta: {
          title: "报名详情"
        }
      },
      {
        path: "activityVoteList",
        component: () =>
          import("@/views/onlineActivity/components/activityVoteList"),
        meta: {
          title: "活动投票",
          keeplive: true
        }
      },
      {
        path: "activityVote",
        component: () =>
          import("@/views/onlineActivity/components/activityVote"),
        meta: {
          title: "活动投票",
          keeplive: true
        }
      },
      {
        path: "voteActivityDesc",
        component: () =>
          import("@/views/onlineActivity/components/voteActivityDesc"),
        meta: {
          title: "活动说明"
        }
      },
      {
        path: "activityDetial",
        component: () =>
          import("@/views/onlineActivity/components/activityDetial"),
        meta: {
          title: "活动详情"
        }
      },
      {
        path: "voteRankList",
        component: () =>
          import("@/views/onlineActivity/components/voteRankList"),
        meta: {
          title: "排行榜"
        }
      },
      {
        path: "uploadVideo",
        component: () =>
          import("@/views/onlineActivity/components/uploadVideo"),
        meta: {
          title: "上传视频"
        }
      },
      {
        path: "uploadVideoResult",
        component: () =>
          import("@/views/onlineActivity/components/uploadVideoResult"),
        meta: {
          title: "上传视频"
        }
      },
      {
        path: "myVideo",
        component: () => import("@/views/onlineActivity/components/myVideo"),
        meta: {
          title: "我的视频"
        }
      },
      {
        path: "myVideoDetail",
        component: () =>
          import("@/views/onlineActivity/components/myVideoDetail"),
        meta: {
          title: "我的视频"
        }
      },
      {
        path: "videoDetial",
        component: () =>
          import("@/views/onlineActivity/components/videoDetial"),
        meta: {
          title: "投票详情"
        }
      },
      {
        path: "videoManage",
        component: () =>
          import("@/views/onlineActivity/components/videoManage"),
        meta: {
          title: "视频管理"
        }
      },
      {
        path: "canvas",
        component: () => import("@/views/onlineActivity/components/canvas"),
        meta: {
          title: "画板"
        }
      },

      {
        path: "askCode",
        component: () => import("@/views/onlineActivity/components/askCode"),
        meta: {
          title: "个人邀请码"
        }
      },
      {
        path: "userRightCenter",
        component: () =>
          import("@/views/onlineActivity/components/userRightCenter"),
        meta: {
          title: "新用户权益中心"
        }
      },
      {
        path: "certDown",
        component: () => import("@/views/onlineActivity/components/certDown"),
        meta: {
          title: "视频中心"
        }
      },
      {
        path: "videoManage",
        component: () =>
          import("@/views/onlineActivity/components/videoManage"),
        meta: {
          title: "视频管理"
        }
      },

      //青协投票的模板，省台的投票模块单独摘出来的
      {
        path: "stactivityVote",
        component: () =>
          import("@/views/onlineActivity/qxcomponents/activityVote"),
        meta: {
          title: "活动投票",
          keeplive: true
        }
      },

      {
        path: "stvideoDetial",
        component: () =>
          import("@/views/onlineActivity/qxcomponents/videoDetial"),
        meta: {
          title: "视频详情"
        }
      },
      {
        path: "stvoteActivityDesc",
        component: () =>
          import("@/views/onlineActivity/qxcomponents/voteActivityDesc"),
        meta: {
          title: "活动说明"
        }
      },
      {
        path: "stvoteRankList",
        component: () =>
          import("@/views/onlineActivity/qxcomponents/voteRankList"),
        meta: {
          title: "排行榜"
        }
      },
      //青协投票的模板，省台的广场舞投票模块单独摘出来的
      {
        path: "danceactivityVote",
        component: () =>
          import("@/views/onlineActivity/dancecomponents/activityVote"),
        meta: {
          title: "活动投票",
          keeplive: true
        }
      },

      {
        path: "dancevideoDetial",
        component: () =>
          import("@/views/onlineActivity/dancecomponents/videoDetial"),
        meta: {
          title: "视频详情"
        }
      },
      {
        path: "dancevoteActivityDesc",
        component: () =>
          import("@/views/onlineActivity/dancecomponents/voteActivityDesc"),
        meta: {
          title: "活动说明"
        }
      },
      {
        path: "dancevoteRankList",
        component: () =>
          import("@/views/onlineActivity/dancecomponents/voteRankList"),
        meta: {
          title: "排行榜"
        }
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/onlineActivity.js